import AnswerItem from "./AnswerItem"
import { sortedUniq } from 'lodash'

export enum QuestionTypeEnum {
  CHECKBOX = 'checkbox',
  RADIO = 'radio',
  SELECT = 'select',
  TEXTFIELD = 'textfield',
  TEXTAREA = 'textarea',
  MULTI_CHECKBOX = 'multi_checkbox',
  INLINE_SELECT = 'inline_select'
}

export class QuestionFieldType {
    public answerItems: AnswerItem[] = []
    
    constructor(public fieldType: string) { }

    public get isTextfield() {
        return this.fieldType == QuestionTypeEnum.TEXTFIELD
    }

    public get isTextarea() {
        return this.fieldType == QuestionTypeEnum.TEXTAREA
    }

    public get isCheckbox() {
        return this.fieldType == QuestionTypeEnum.CHECKBOX
    }

    public get isMultiCheckbox() {
        return this.fieldType == QuestionTypeEnum.MULTI_CHECKBOX
    }

    public get isRadio() {
        return this.fieldType == QuestionTypeEnum.RADIO
    }

    public get isSelect() {
        return this.fieldType == QuestionTypeEnum.SELECT
    }

    public get isInlineSelect() {
        return this.fieldType == QuestionTypeEnum.INLINE_SELECT
    }

    public get isUnknowType() {
        return !this.fieldType
    }

    public get answerItemScopes() : AnswerItem[][]{
        const scopeIds: number[] = sortedUniq(this.answerItems.map(item => item.scopeId)) 
        return scopeIds.map(scopeId => {
            return this.answerItems.filter(answerItem => answerItem.scopeId === scopeId)
        })
    }
}